// noinspection JSAnnotator
const state = {
  userDetails: [],
  adminUser: false,
  activeLink: '',
};

// noinspection JSAnnotator
const mutations = {
  'SET_USER_DETAILS'(state, detail) {
    if (detail) {
      state.userDetails = detail;
      if (state.userDetails.userRoleId == 1) {
        state.adminUser = true;
      } else {
        state.adminUser = false;
      }
    }
  },
  'UPDATE_USER_DETAILS'(state, detail) {
    state.userDetails.unshift(detail);
  }
};

const actions = {
  setUserDetails: ({commit}, detail) => {
    commit('SET_USER_DETAILS', detail);
  },
  updateUserDetails: ({commit}, detail) => {
    commit('UPDATE_USER_DETAILS', detail);
  }
};

const getters = {
  getUserDetails: (state) => {
    return state.userDetails;
  },
  getAdminUser: (state) => {
    return state.adminUser;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/User.store.js